// extracted by mini-css-extract-plugin
export default {"icon":"BaseIcon-module-icon--0cd6d"};